import moment from 'moment';
import { setActiveLanguage } from 'react-localize-redux';
import store from '../store';

export const getBrowserLocale = (currentLanguage) => currentLanguage.replace('_', '-');

export const getLocalizedString = (item, lang) => {
  if (item === undefined || !item) {
    return null;
  }
  return lang === 'fi'
    ? item.fi_FI
    : item.en_US;
};

export const getLocalizedName = (item, lang) => {
  if (item === undefined || !item) {
    return null;
  }
  return getLocalizedString(item.name, lang);
};

export const getLocalizedDate = (date, currentLanguage) => {
  const dateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  };

  const locale = getBrowserLocale(currentLanguage);

  return date.toLocaleDateString(locale, dateOptions);
};

export const getLocalizedDateWithWeekday = (date, currentLanguage) => {
  const dateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  };

  const locale = getBrowserLocale(currentLanguage);

  return date.toLocaleDateString(locale, dateOptions);
};

export const getLocalizedTime = (date, currentLanguage) => {
  const dateOptions = {
    hour: 'numeric',
    minute: 'numeric',
  };

  const locale = getBrowserLocale(currentLanguage);

  return date.toLocaleTimeString(locale, dateOptions);
};

export const getLocalizedDateTime = (date, currentLanguage) => {
  const dateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  const locale = getBrowserLocale(currentLanguage);

  return date.toLocaleDateString(locale, dateOptions);
};

export const updateLanguage = (language) => {
  moment.locale(language);
  store.dispatch(setActiveLanguage(language));
  localStorage.setItem('user-language', language);
};
